import * as XLSX from 'xlsx';

export function buildReviewsExportRows(reviews) {
  return reviews.map((r) => ({
    Cliente: r.name,
    Produto: r.product?.name || '',
    Nota: r.rating,
    Mensagem: r.message,
    Data: new Date(r.createdAt).toLocaleString('pt-BR'),
    Status: r.isDeleted ? 'Inativa' : 'Ativa',
  }));
}

export function exportReviewsToXls(reviews, fileName = 'avaliacoes.xlsx') {
  const rows = buildReviewsExportRows(reviews);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Avaliações');
  XLSX.writeFile(workbook, fileName);
}
